import { ArrayUtils, EnumUtils } from '@colonist/utils';
import { CardEnum, CardTypeEnum } from '@colonist/game-states';
import { getResourceCardData } from './ResourceCardData.ts';
import { getAnyResourceCardData } from './AnyResourceCardData.ts';
import { getDevelopmentCardData } from './DevelopmentCardData.ts';
import { getCommodityCardData } from './CommodityCardData.ts';
import { getProgressCardDataScience } from './ProgressCardDataScience.ts';
import { getProgressCardDataTrade } from './ProgressCardDataTrade.ts';
import { getProgressCardDataPolitics } from './ProgressCardDataPolitics.ts';
import { getMiscellaneousCardData } from './MiscellaneousCardData.ts';
export class CardDataController {
    static getCardDataForCard(cardEnum) {
        if (typeof cardEnum == 'string') cardEnum = parseInt(cardEnum, 10);
        return this.cardMap.get(cardEnum);
    }
    static getBaseCardDataForType(cardTypes) {
        const cardEnums = this.getCardEnumsOfTypes(cardTypes);
        const cardDataForType = [];
        for (const cardEnum of cardEnums){
            const cardData = this.getCardDataForCard(cardEnum);
            if (cardData == undefined) continue;
            cardDataForType.push(cardData);
        }
        return cardDataForType;
    }
    static getCardTypeFromCardEnum(cardEnum) {
        var _this_getCardDataForCard;
        return (_this_getCardDataForCard = this.getCardDataForCard(cardEnum)) === null || _this_getCardDataForCard === void 0 ? void 0 : _this_getCardDataForCard.cardTypeEnum;
    }
    static getCardBackOfCard(cardEnum) {
        if (typeof cardEnum == 'string') cardEnum = parseInt(cardEnum, 10);
        return this.cardToCardBackMap.get(cardEnum);
    }
    static getCardEnumsOfTypes(cardTypes) {
        const cardEnums = [];
        for (const card of this.cardDataList){
            if (card.isCardBack) continue;
            if (!ArrayUtils.elementInArray(cardTypes, card.cardTypeEnum)) continue;
            cardEnums.push(card.cardEnum);
        }
        return cardEnums;
    }
    static areCardsValidInputForType(cardsToCheck, validCardTypes) {
        const uniqueCardsToCheck = ArrayUtils.removeDuplicatesFromArray(cardsToCheck);
        for (const cardEnum of uniqueCardsToCheck){
            const cardData = this.getCardDataForCard(cardEnum);
            if (cardData == undefined) continue;
            if (cardData.isCardBack) return false;
            if (!ArrayUtils.elementInArray(validCardTypes, cardData.cardTypeEnum)) return false;
        }
        return true;
    }
    static isResourceCard(cardEnum) {
        const cardData = this.getCardDataForCard(cardEnum);
        if (cardData == undefined) return false;
        if (cardData.cardTypeEnum == CardTypeEnum.Resource) return true;
        if (cardData.cardTypeEnum == CardTypeEnum.Commodity) return true;
        return false;
    }
    static isDevelopmentOrProgressCard(cardEnum) {
        const cardData = this.getCardDataForCard(cardEnum);
        if (cardData == undefined) return false;
        if (cardData.cardTypeEnum == CardTypeEnum.Development) return true;
        if (cardData.cardTypeEnum == CardTypeEnum.ProgressTrade) return true;
        if (cardData.cardTypeEnum == CardTypeEnum.ProgressPolitics) return true;
        if (cardData.cardTypeEnum == CardTypeEnum.ProgressScience) return true;
        return false;
    }
    static getCardBacksForCards(cardEnums) {
        return cardEnums.map((cardEnum)=>this.getCardBackOfCard(cardEnum)).filter((cardEnum)=>cardEnum != undefined);
    }
    static compareCardDisplayOrder(cardA, cardB) {
        var _this_cardOrderMap_get;
        const indexA = (_this_cardOrderMap_get = this.cardOrderMap.get(cardA)) !== null && _this_cardOrderMap_get !== void 0 ? _this_cardOrderMap_get : this.cardDataList.length;
        var _this_cardOrderMap_get1;
        const indexB = (_this_cardOrderMap_get1 = this.cardOrderMap.get(cardB)) !== null && _this_cardOrderMap_get1 !== void 0 ? _this_cardOrderMap_get1 : this.cardDataList.length;
        return indexA - indexB;
    }
    static sortCards(cards) {
        return [
            ...cards
        ].sort((cardA, cardB)=>this.compareCardDisplayOrder(cardA, cardB));
    }
}
CardDataController.cardDataList = [
    ...getResourceCardData(),
    ...getCommodityCardData(),
    ...getAnyResourceCardData(),
    ...getDevelopmentCardData(),
    ...getProgressCardDataScience(),
    ...getProgressCardDataTrade(),
    ...getProgressCardDataPolitics(),
    ...getMiscellaneousCardData()
];
CardDataController.cardMap = new Map(CardDataController.cardDataList.map((card)=>[
        card.cardEnum,
        card
    ]));
CardDataController.cardToCardBackMap = new Map(CardDataController.cardDataList.map((card)=>{
    var _CardDataController_cardDataList_filter_find;
    return [
        card.cardEnum,
        (_CardDataController_cardDataList_filter_find = CardDataController.cardDataList.filter((possibleBackCard)=>{
            var _CardDataController_cardMap_get;
            return ((_CardDataController_cardMap_get = CardDataController.cardMap.get(card.cardEnum)) === null || _CardDataController_cardMap_get === void 0 ? void 0 : _CardDataController_cardMap_get.cardTypeEnum) == possibleBackCard.cardTypeEnum;
        }).find((possibleBackCard)=>possibleBackCard.isCardBack)) === null || _CardDataController_cardDataList_filter_find === void 0 ? void 0 : _CardDataController_cardDataList_filter_find.cardEnum
    ];
}));
CardDataController.cardOrderMap = new Map(CardDataController.cardDataList.map((card, index)=>[
        card.cardEnum,
        index
    ]));
(()=>{
    const expectedEnums = EnumUtils.getEnumValues(CardEnum);
    const actualEnums = CardDataController.cardDataList.map((c)=>c.cardEnum);
    if (expectedEnums.length !== actualEnums.length) {
        throw new Error(`CardDataController: cardDataList does not contain exactly ${expectedEnums.length} cards`);
    }
    const uniqueActualEnums = new Set(actualEnums);
    if (uniqueActualEnums.size !== actualEnums.length) {
        throw new Error('CardDataController: cardDataList contains duplicate CardEnums');
    }
})();
